import { render, staticRenderFns } from "./BounceDetailsPage.vue?vue&type=template&id=6a23637c&scoped=true"
import script from "./BounceDetailsPage.vue?vue&type=script&lang=js"
export * from "./BounceDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./BounceDetailsPage.vue?vue&type=style&index=0&id=6a23637c&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a23637c",
  null
  
)

export default component.exports